import {fetchRemoteResult} from '@core/Api/api-util';
import ApiBase from "@core/Api/api-base";

/**
 * Get sankey data for the given journey using the given endpoint as base endpoint
 * 
 * @param {string} endpoint Sankey endpoint
 * @param {String} [journeyId]
 * @param {JourneyReportStatisticsParameters} requestParameters 
 * @return {Promise<{ types: SankeyType[], data: SankeyNode[] }>}
 */
const getJourneyDataFromEndpoint = (endpoint, journeyId, requestParameters) => {
    let queryParams = {};
    
    //We assume our journeyId to be part of the route
    if(journeyId){
        if(!endpoint.endsWith('/')){
            endpoint += '/';   
        }
        
        endpoint += journeyId;
    }
    
    if(requestParameters.periodId) queryParams['periodId'] = requestParameters.periodId;
    if(requestParameters.inflowPeriodId) queryParams['inflowPeriodId'] = requestParameters.inflowPeriodId;
    if(requestParameters.productNames.length) queryParams['productNames'] = requestParameters.productNames;
    
    const params = ApiBase.parameterize(queryParams);
    
    if(params){
        if(endpoint.includes('?')){
            endpoint += '&';
        } else {
            endpoint += '?';
        }
        
        endpoint += params;
    }
    
    return getDataFromEndpoint(endpoint);
};

/**
 * Get sankey data from the given endpoint
 * 
 * @param {RequestInfo} endpoint
 * @return {Promise<{ types: SankeyType[], data: SankeyNode[] }>}
 */
const getDataFromEndpoint = async (endpoint) => {

    const errorMsg = 'Please make sure response from api contains two arrays named data and types.'

    const value = await fetchRemoteResult(endpoint);

    if(
        !value || 
        !Array.isArray(value.types) ||
        !Array.isArray(value.data)
    ){
        console.error(errorMsg);
        throw errorMsg;
    }
    
    return value;
    
    // return new Promise((resolve, reject) => {
    //     fetchRemoteResult(endpoint).then(
    //         (value) => {
    //             if(value && value.types && value.data) {
    //                 if(Array.isArray(value.types) && Array.isArray(value.data)) {
    //                     resolve({
    //                         types: value.types,
    //                         data: value.data
    //                     });
    //                 } else {
    //                     console.error(errorMsg);
    //                     reject(errorMsg);
    //                 }
    //             } else {
    //                 console.error(errorMsg);
    //                 reject(errorMsg);
    //             }
    //         },
    //         (error) => {
    //             console.error(error);
    //             reject(error);
    //         }
    //     );
    // });
};

export default {
    getJourneyDataFromEndpoint,
    getDataFromEndpoint
};